import './style.scss';
import { Timer } from '../../../js/components/Timer/Timer';
import { getCookie } from '../../../js/utils/cookies';
import { saleEndDate } from '../../../js/components/SaleEndDate/SaleEndDate'

export default !function () {
  const block = document.querySelector('.price-v8');

  if (!block) {
    return;
  }

  const blockName = block.dataset.blockName || 'Блок без названия'
  const form = block.querySelector('.form');

  form && form.addEventListener('form-sended', (evt) => {
    const { formData } = evt.sendingResult;
    const requestId = formData.get('request_id');

    window.$analytics?.push('price-form-send', {
      requestId,
      label: 'No options',
      blockName
    })

    // Отпрывает ссылку в новом окне с сохранением utm меток
    let url = form.dataset.redirectUrl;

    if (url) {
      const utmFromCookie = getCookie('utm_aggregated_data');

      if (utmFromCookie) {
        url = `${url}?${utmFromCookie.replace(/\|\|\|/g, '&')}`
      }

      window.open(url, '_blank');
    }
  });

  // init timer
  const timerWrapper = block.querySelector('.price-v8__timer-block')
  const timer = timerWrapper?.querySelector('[data-type=timer]')

  if (timerWrapper && timer) {
    const tick = ({ days, daysWord, hours, minutes, seconds }) => {
      timer.innerHTML = `${days ? `<b class="f f--m">${days}</b>&nbsp;${daysWord}&nbsp;` : ''}<b class="f f--m">${hours}:${minutes}:${seconds}</b>`
    }

    saleEndDate
      .addObserver(time => new Timer({ time, timerWrapper, tickCallback: tick }))
  }

  /* b2b */
  const b2b = block.querySelector('.ui-checkbox-field__input[name="is_jur_person"]');

  if (b2b) {
    const companyInput = block.querySelector('[data-field="b2b"]');
    const companyField = companyInput.closest('.form__input--hidden');

    setTimeout(() => {
      if (b2b.checked) {
        companyField.classList.add('form__input--show');
      }
    }, 100)

    b2b.addEventListener('change', () => {
      companyField.classList.toggle('form__input--show');
      companyInput.disabled = !b2b.checked;
    });
  }
  /* end b2b */
}();
